import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { nextStep } from '../../store/formSlice';
import { Button, Box, Text, Image, VStack } from '@chakra-ui/react';
import StepHeader from './StepHeader';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Quotes } from '../../utils/Images';

const testimonials = [
    {
        quote:
            "As a caregiver at an assisted living facility, Sophie has been a true game-changer for our residents. Its daily calls provide meaningful conversations tailored to each individual, helping them feel more connected and valued. I’ve noticed a significant improvement in their overall mood and mental sharpness, thanks to the cognitive stimulation Sophie offers through engaging topics and activities. Even on busy days when I can’t give each resident my full attention, I know they’re receiving care and companionship that truly makes a difference in their well-being.",
        author: "Ohn Alvarez",
        role: "Professional Caregiver, New York, NY",
    },
    {
        quote:
            "Sophie has completely transformed my grandmother’s life. She used to feel so alone, but now she looks forward to her daily calls and always has a smile after speaking with Sophie.",
        author: "Sarah Taparoff",
        role: "Granddaughter, Austin, TX",
    },
    {
        quote:
            "My father has always been a quiet man since the loss of our mom, but Sophie has helped him open up and share stories I haven’t heard before. It’s been amazing to see him so engaged and happy.",
        author: "Vanessa Park",
        role: "Daughter, Los Angeles, CA",
    },
    {
        quote:
            "Sophie feels like a true companion for my mother, offering someone to listen, chat, and brighten her day. What’s super reassuring is that I can access insights about their conversations and see tangible improvements in her mood and engagement over time. It’s a comforting way to stay connected and involved in her well-being, even from a distance. ",
        author: "Janika Chapman",
        role: "Family Member, Chicago, IL",
    },
];

const SocialProofStep = () => {
    const dispatch = useDispatch();

    const handleContinue = () => {
        dispatch(nextStep());
    };

    let sliderRef = useRef(null);

    const settings = {
        centerMode: true,
        centerPadding: '0px',
        className: "center",
        slidesToShow: 3,
        infinite: true,
        speed: 500,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 2000,
        swipeToSlide: true,
        adaptiveHeight: true,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    infinite: true,
                    speed: 500,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: false,
                    autoplaySpeed: 2000,
                    swipeToSlide: true,
                    adaptiveHeight: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    speed: 500,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: false,
                    autoplaySpeed: 2000,
                    swipeToSlide: true,
                    adaptiveHeight: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    speed: 500,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: false,
                    autoplaySpeed: 2000,
                    swipeToSlide: true,
                    adaptiveHeight: true
                }
            }
        ]
    };

    return (
        <Box maxW="90vw" mx="auto" p={6} textAlign="center">
            <StepHeader
                title="Social Proof"
                subtitle='"Hear What Families Say About Sophie Care"'
            />
            <Box mb={8} bg="#1080841A" borderRadius="lg" p={4}>
                <Slider {...settings} ref={slider => (sliderRef = slider)}>
                    {testimonials.map((testimonial, index) => (
                        <Box
                            key={index}
                            className="testimonial-slide"
                            bg="gray.50"
                            borderRadius="lg"
                            py={{ base: 4, md: 6 }}
                            px="20px"
                            boxShadow="md"
                            textAlign="center"
                            mx={2}
                            minH={{ base: '340px', md: '340px' }} // Ensures equal height
                            display="flex !important"
                            flexDirection="column"
                            justifyContent="center"
                        >
                            <Image src={Quotes} mx="auto" height="37px" width="56px" mb={4} />
                            <Text fontSize={{ base: '16px', md: '16px' }} color="black" mb={4}>
                                {testimonial.quote}
                            </Text>
                            <VStack mt="auto" mb={0} spacing={0} justify="flex-end">
                                <Text fontSize={{ base: '22px', md: '25px' }} color="brand.600" fontWeight="bold" mb={1}>
                                    {testimonial.author}
                                </Text>
                                <Text fontSize="14px" color="black">
                                    {testimonial.role}
                                </Text>
                            </VStack>
                        </Box>
                    ))}
                </Slider>
            </Box>
            <style>{`
                .testimonial-slide {
                    opacity: 0.5;
                    transform: scale(0.85);
                    transition: all 0.3s;
                }
                .slick-center .testimonial-slide {
                    opacity: 1 !important;
                    transform: scale(0.9);
                    background: #fff;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.10);
                    z-index: 2;
                }
                .slick-slide {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                }
                // .slick-list {
                // background: #1080841A
                // }
            `}</style>
            <Button
                onClick={handleContinue}
                mt={4}
                px="30px"
            >
                Continue
            </Button>
        </Box>
    );
};

export default SocialProofStep;